export default class PatternsUtils {
  static FULL_NAME_MIN_2_CHARS =
    /^(?=.*?[\p{L} ]{2,})[\p{L} ]{2,}\s(?=.*?[\p{L} ]{2,})[\p{L} ]{2,}$/u;

  static FULL_NAME_MIN_3_CHARS = /^[\p{L}]{3,}(?: [\p{L}]{3,})+$/u;

  static CPF_MAX_14_CHARS = /[0-9]{3}\.?[0-9]{3}\.?[0-9]{3}\-?[0-9]{2}/;

  static CNPJ = /^([A-Z\d]){12}(\d){2}$/

  static EMAIL = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;

  static NO_SPECIAL_CHARS = /^[\p{L} ]+[0-9]*$/u;

  static WITH_SPECIAL_CHARS = /^[\p{L} 0-9\W]*$/u;

  static ONLY_NUMBERS = /^[0-9]+$/;

  static BANK_ACCOUNT_NUMBER = /^[0-9]{5,11}-[0-9]$/;

  static BANK_ACCOUNT_NUMBER_LETTER = /^[0-9]{5,28}-[A-Za-z0-9]{1}$/;

  static ONLY_LETTERS = /^[\p{L} ]*$/u;

  static ONLY_LETTERS_WITH_HYPHEN = /^(?=.*[\p{L}\-])[\p{L}\- ]+$/u;

  static ONLY_NUMBER_AND_LETTERS = /^[\p{L} 0-9]*$/u;

  static BR_DDD_PHONE_NUMBER = /(?:(^\+\d{2})?)(?:([1-9]{2})|([0-9]{3})?)(\d{4,5})(\d{4})/;

  static NUMERO_MATRICULA = /^[a-zA-Z0-9.-]*$/;

  static CEP = /\d{5}-?\d{3}/;
}
